import { FaQuestion } from 'react-icons/fa';
import { IconButtonProps as ChakraIconButtonProps, IconButton as ChakraIconButton } from '@chakra-ui/react';
import { ComponentStyleConfig } from '@chakra-ui/theme';
import { primaryThemeGradientDark } from 'constants/theme';

export type IconButtonProps = ChakraIconButtonProps;

const IconButtonStyles: ComponentStyleConfig = {
  baseStyle: {
    _disabled: {
      _hover: {
        bg: primaryThemeGradientDark,
      },
    },
  },
  sizes: {
    sm: {
      fontSize: 'sm',
      borderRadius: 6,
      px: 2.5,
      py: 3.5,
      h: 18,
    },
    md: {
      fontSize: 'md',
      borderRadius: 6,
      px: 2.5,
      py: 3.5,
      h: 7,
    },
    lg: {
      fontSize: 'md',
      borderRadius: 26,
      px: 36,
      py: 4,
    },
  },
};

const IconButton = ({ size = 'sm', variant = 'round', icon = <FaQuestion />, ...props }: IconButtonProps) => (
  <ChakraIconButton size={size} variant={variant} icon={icon} borderRadius={6} w={10} fontSize="14px" {...props} />
);

export { IconButton, IconButtonStyles };
